import { useQuery } from '@office-start/data-fetching';
import { getFirstRunState } from '../fetchState/getFirstRunState';
import { getNewUserQueryFn } from '../helpers/getNewUserQueryFn';
import { FirstRunStorageKey } from '../models/Constants';
export function useFirstRunState() {
    var query = [FirstRunStorageKey];
    return useQuery(query, getNewUserQueryFn(getFirstRunState), {
        staleTime: Infinity,
        cacheTime: Infinity,
    });
}
//# sourceMappingURL=useFirstRunState.js.map